import { render, staticRenderFns } from "./table4.vue?vue&type=template&id=3badab98&scoped=true&"
import script from "./table4.vue?vue&type=script&lang=js&"
export * from "./table4.vue?vue&type=script&lang=js&"
import style0 from "./table4.vue?vue&type=style&index=0&lang=css&"
import style1 from "./table4.vue?vue&type=style&index=1&id=3badab98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3badab98",
  null
  
)

export default component.exports